import React, { FC } from 'react';

export const Error: FC = () => {
  return <div>ErrorPage</div>;
};

export default Error;
